const TusdConfig = (props = {}) => {
  const headers = {};
  const metadata = {};

  if (props.signature) {
    headers.Authorization = props.signature;
  }

  if (props.path?.length) {
    metadata.storepath = props.path;
  }

  if (!props.tusdUrl?.length) {
    throw new Error('Missing required prop tusdUrl');
  }
  return {
    endpoint: props.tusdUrl,
    uploadUrl: props.tusdUrl,
    chunkSize: 5242880, // exactly 5mb in bytes. Aws S3 defaults to multi-part part sizes at this length
    removeFingerprintOnSuccess: true,
    headers,
    metadata
  };
};

export default TusdConfig;
